import { render } from "./PayrollReview.vue?vue&type=template&id=2f696bdd"
import script from "./PayrollReview.vue?vue&type=script&lang=js"
export * from "./PayrollReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__